/**
 * Rate Card tab — plan §11 item 3 ("Rate Card: two views. Card: site
 * selector, therapeutic-area toggle, search; sections per-patient, unitized,
 * site fees, overhead and holdback, screen-fail, stipends, staff rates; Low,
 * Preferred, High with datapoint drill-down; pending datapoints to accept;
 * overrides; sub-sections Medicare lookup and Industry. Outcomes: one row
 * per negotiation with the metric set ..."). §13.5 WP-41 replaces the WP-03
 * placeholder with the Card view and the Medicare / Industry / Outcomes
 * MOUNT POINTS only — WP-43 (Medicare), WP-44 (Industry) and WP-72
 * (Outcomes) replace those placeholders with the real screens later, the
 * same labelled-slot pattern AdminTab.tsx uses for its own later-WP panels.
 * This file (and everything else in tabs/rateCard/ except its medicare/,
 * industry/ and outcomes/ sub-folders, which are not this WP's to create)
 * is owned by WP-41.
 *
 * Naming note (repo conventions): this tab is "Rate Card", not "budget" — a
 * bare "budget" identifier means AI spend caps elsewhere in this codebase
 * (mhrBudget.js, crmAgentBudget.js).
 */
import { useState } from 'react';
import { Table as TableIcon } from 'lucide-react';
import { PageHeader, SegmentedTabs } from '../../../ui';
import { CardView } from './CardView';
import { OutcomesView } from './outcomes/OutcomesView';

type TopView = 'card' | 'outcomes';

export function RateCardTab() {
  const [view, setView] = useState<TopView>('card');

  return (
    <div className="mx-auto w-full max-w-[1700px] space-y-4 p-4 sm:p-6 lg:p-8">
      <PageHeader
        title="Rate Card"
        icon={TableIcon}
        subtitle="What WCR has actually been paid — Low, Preferred and High, by scope and therapeutic area (§7.1, §7.2)."
      />

      <SegmentedTabs
        label="Rate card view"
        value={view}
        onChange={(v) => setView(v as TopView)}
        tabs={[
          { value: 'card', label: 'Card' },
          { value: 'outcomes', label: 'Outcomes' },
        ]}
      />

      {view === 'card' ? (
        <CardView />
      ) : (
        <OutcomesView />
      )}
    </div>
  );
}

export default RateCardTab;
